import { BillingPlanFeature, useBillingEnabledFeatures } from 'resources/Organization/Features';
import type { ValueOf } from 'type-fest';

export const leadsEnabledState = {
  loading: 'loading',
  enabled: 'enabled',
  disabled: 'disabled',
} as const;

export const useIsLeadsFeatureEnabled = (): ValueOf<typeof leadsEnabledState> => {
  const { data: enabledFeatures, isLoading } = useBillingEnabledFeatures({ refetchOnMount: false });

  if (isLoading) {
    return leadsEnabledState.loading;
  }

  const isEnabledByBilling = enabledFeatures?.includes(BillingPlanFeature.FEATURE_SALES_MANAGEMENT);

  if (isEnabledByBilling) {
    return leadsEnabledState.enabled;
  }

  return leadsEnabledState.disabled;
};
